var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService247Animate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-service-247",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-service-247:not(.animated) .animable {opacity: 0;}svg#freepik_stories-service-247.animated #freepik--background-complete--inject-28 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-service-247.animated #freepik--Table--inject-28 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-service-247.animated #freepik--Text--inject-28 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-service-247.animated #freepik--Stopwatch--inject-28 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-service-247.animated #freepik--speech-bubble--inject-28 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-service-247.animated #freepik--Character--inject-28 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}            @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-28",
    className: "animable",
    style: {
      transformOrigin: "240.71px 240.654px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169,34.74a19,19,0,0,1,4.65-2l.95-4.59,7.76-.14,1.12,4.56a19.15,19.15,0,0,1,4.71,1.85l3.92-2.57,5.59,5.4-2.43,4a18.88,18.88,0,0,1,2,4.64l4.59.95L202,54.6l-4.56,1.11a19,19,0,0,1-1.85,4.71l2.57,3.93-5.4,5.58-4-2.43a18.88,18.88,0,0,1-4.64,2l-1,4.59-7.76.14-1.12-4.56a19.08,19.08,0,0,1-4.7-1.85l-3.93,2.57L160,65l2.43-4a19,19,0,0,1-2-4.65l-4.59-1-.14-7.76,4.56-1.12a19.15,19.15,0,0,1,1.85-4.71l-2.57-3.93L165,32.31l4,2.43Zm4.14,10.34a8.33,8.33,0,1,0,11.78-.2A8.34,8.34,0,0,0,173.1,45.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "178.85px 51.12px"
    },
    id: "elf8zsejbkviu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.8,292.28a10.93,10.93,0,0,1,2.68-1.16l.55-2.65,4.48-.08.64,2.63a10.89,10.89,0,0,1,2.72,1.06l2.26-1.48,3.22,3.11L186,296a10.93,10.93,0,0,1,1.16,2.68l2.65.55.08,4.48-2.63.64a10.89,10.89,0,0,1-1.06,2.72l1.48,2.26-3.11,3.22-2.31-1.4a11.36,11.36,0,0,1-2.68,1.17L179,315l-4.48.08-.64-2.63a10.89,10.89,0,0,1-2.72-1.06l-2.26,1.48-3.22-3.11,1.4-2.31a11.36,11.36,0,0,1-1.17-2.68l-2.64-.55-.08-4.48,2.63-.64a10.89,10.89,0,0,1,1.06-2.72l-1.48-2.26,3.11-3.22,2.31,1.4Zm2.39,6a4.81,4.81,0,1,0,6.79-.12A4.8,4.8,0,0,0,173.19,298.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "176.54px 301.735px"
    },
    id: "eludkq4f4jfq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.28,59.43a7.6,7.6,0,0,1,1.83-.8l.38-1.81,3.05,0L79,58.56a8,8,0,0,1,1.86.73l1.54-1,2.2,2.12-1,1.58a7.6,7.6,0,0,1,.8,1.83l1.81.38,0,3-1.8.44a7.54,7.54,0,0,1-.72,1.86l1,1.54-2.12,2.2-1.58-1a7.6,7.6,0,0,1-1.83.8l-.38,1.81-3,0-.44-1.8a7.54,7.54,0,0,1-1.86-.72l-1.54,1-2.2-2.13,1-1.57a7.6,7.6,0,0,1-.8-1.83l-1.81-.38-.05-3,1.79-.44a8,8,0,0,1,.73-1.86l-1-1.54,2.12-2.2,1.58,1Zm1.63,4.07a3.28,3.28,0,1,0,4.64-.08A3.28,3.28,0,0,0,74.91,63.5Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "77.145px 65.835px"
    },
    id: "elj5icx8p8nq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.56,53a14.8,14.8,0,0,1,3.61-1.57l.74-3.57,6-.11.87,3.55a14.74,14.74,0,0,1,3.67,1.44l3-2L244.88,55,243,58.08a14.66,14.66,0,0,1,1.57,3.62l3.58.74.1,6-3.54.87A15.1,15.1,0,0,1,243.25,73l2,3.06-4.19,4.34-3.12-1.89a15,15,0,0,1-3.61,1.57l-.75,3.57-6,.11-.87-3.55A14.67,14.67,0,0,1,223,78.78l-3,2-4.35-4.19,1.89-3.12a15,15,0,0,1-1.57-3.62l-3.57-.74-.11-6,3.55-.87a14.67,14.67,0,0,1,1.44-3.66l-2-3.06,4.19-4.34L222.56,53Zm3.22,8a6.48,6.48,0,1,0,9.16-.17A6.47,6.47,0,0,0,225.78,61.08Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "230.27px 65.755px"
    },
    id: "el3zseu97np2s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.21,202.1a18.82,18.82,0,0,1,4.63-2l1-4.59,7.75-.14,1.12,4.56a18.76,18.76,0,0,1,4.71,1.85l3.91-2.57,5.58,5.39-2.42,4a19.41,19.41,0,0,1,2,4.64l4.59,1,.14,7.75-4.56,1.12a18.69,18.69,0,0,1-1.85,4.7l2.57,3.92L406,237.25l-4-2.43a19,19,0,0,1-4.64,2l-1,4.59-7.75.13L387.49,237a19.08,19.08,0,0,1-4.7-1.85l-3.92,2.57-5.58-5.39,2.43-4a18.82,18.82,0,0,1-2-4.63l-4.59-1L369,215l4.55-1.12a19.15,19.15,0,0,1,1.85-4.71l-2.57-3.91,5.39-5.58,4,2.43Zm4.13,10.33a8.32,8.32,0,1,0,11.77-.21A8.31,8.31,0,0,0,386.34,212.43Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "392.11px 218.455px"
    },
    id: "elfxy8qmn11eh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,51.22A21,21,0,1,0,397.9,61.83h0l.06.08c.8,1.36,1.81,2.33,2.83,3.75L413,81.82a3.79,3.79,0,0,0,6,0l12-15.89a45.13,45.13,0,0,0,3.05-4l.05-.06h0A20.88,20.88,0,0,0,437,51.22Zm-21,9.14a9.24,9.24,0,1,1,9.25-9.24A9.24,9.24,0,0,1,416,60.36Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "416px 56.7378px"
    },
    id: "el6jgu1j8zgyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.27,353.45a13.24,13.24,0,0,0,5.41-13.54c-1.37-7.19-8-12-14.69-10.71s-11.1,8.15-9.73,15.35a13.21,13.21,0,0,0,10.13,10.63C40.17,361.66,45,381.9,45,381.9l44.43-8.44S86.43,352.64,67.27,353.45Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "66.9251px 355.445px"
    },
    id: "ellmnn50orajq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,439.73,112,437.47s-1.89,7.68-9.91,5.85a7.62,7.62,0,0,1-6-6.49,8.42,8.42,0,0,1,2.47-7.24c2.18-2.18,6.16-3.67,12-1.06l5.09-20.63-9.05-2.23-3,12.09s-13.49.15-16.93,14.13c-3.3,13.38,7.93,19.44,13.07,20.7C103.68,453.56,117.29,455.91,121.1,439.73Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "103.587px 429.484px"
    },
    id: "el72icj07rjp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt4l1tout6t"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.46,
    y: 393.83,
    width: 9.45,
    height: 8.83,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "113.185px 398.245px",
      transform: "rotate(-166.16deg)"
    },
    className: "animable",
    id: "elymgcli1bm7l"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-28",
    className: "animable",
    style: {
      transformOrigin: "250.735px 470.9px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.12,470.9c0,.14-97.34.26-217.38.26S33.35,471,33.35,470.9s97.31-.26,217.39-.26S468.12,470.75,468.12,470.9Z",
    id: "elk369z3icbtg",
    className: "animable",
    style: {
      transformOrigin: "250.735px 470.9px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-28",
    className: "animable",
    style: {
      transformOrigin: "121.795px 219.715px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,219.2H78.89l-1.84,9.37H39.42l1.49-7.45,22.65-17.75c5.6-4.48,7.31-7.1,7.31-10.37s-2.49-5.47-7.31-5.47A13.76,13.76,0,0,0,53,192.72l-7.74-5.61c4-5.47,11.43-9.09,20-9.09,10.51,0,17.39,5.61,17.39,13.35,0,5.89-2.69,10.86-11.43,17.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "61.035px 203.295px"
    },
    id: "elji3qfz755db",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.66,218.14H120.5l-2.06,10.43H107.22l2.13-10.43H82.58l1.49-7.74,29.26-31.53h12.56L98.63,208.76h13.06l1.85-9.3h10.72l-1.85,9.3h8.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "106.58px 203.72px"
    },
    id: "elb6o21u2fvfa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.46,168.79h10.37l-36.49,66.88H125Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "148.415px 202.23px"
    },
    id: "el6neqxnumafd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.82,178.87l-1.49,7.46-26.55,42.24H168l25.48-40.33H177.37l-1.64,8.1H165.51L169,178.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "187.165px 203.72px"
    },
    id: "el5kvx3ie40qp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.77,267.78l2.91-5.52a16.34,16.34,0,0,0,8.68,2.57c2.84,0,4.48-.89,4.48-2.31,0-3.51-12.68-1.57-12.68-9.77,0-5.63,4.81-9.32,12.53-9.32a18.27,18.27,0,0,1,9.39,2.24l-2.68,5.48a13.48,13.48,0,0,0-7.16-2c-3.06,0-4.7,1.12-4.7,2.54,0,3.58,12.68,1.53,12.68,9.58,0,5.59-4.92,9.28-12.56,9.28C41.18,270.57,37.12,269.38,34.77,267.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "47.425px 256.985px"
    },
    id: "elyi5ui2zrtq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.37,249.66l-.85,4.4H82.11L81,259.57H69.4l-.94,4.78H82.15l-1.2,5.7H60L65.26,244H85.69l-1.16,5.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "72.845px 257.025px"
    },
    id: "elx75bfhwrqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.73,262.22l4.44,7.83h-7.72l-3.88-6.93H93.85l-1.38,6.93H85.09L90.3,244h11.15c6.67,0,10.51,3.1,10.51,8.32A10.07,10.07,0,0,1,104.73,262.22Zm-4.32-12.45H96.53L95,257.41h4.4c3.25,0,5.15-1.56,5.15-4.43C104.51,250.78,102.94,249.77,100.41,249.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.5264px 257.025px"
    },
    id: "el7t8kj34yd7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.31,244,128,270.05h-7.27L114.75,244h7.57l3.73,17,10.66-17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "129.53px 257.025px"
    },
    id: "eldl1lso7xyho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.87,244h7.39L148,270.05h-7.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "146.94px 257.025px"
    },
    id: "elinjxleh3iup",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.41,259.09c0-9.06,6.67-15.66,16.36-15.66,4.81,0,8.73,1.76,10.59,4.92L176,252.6a6.34,6.34,0,0,0-5.74-3c-5.07,0-8.43,3.91-8.43,9.05,0,3.51,2.39,5.86,6.38,5.86a8.18,8.18,0,0,0,6.37-3l4.36,4.28c-2.94,3.55-6.78,4.85-11.44,4.85C159.52,270.57,154.41,265.91,154.41,259.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.885px 257.035px"
    },
    id: "elar0w219j20i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.13,249.66l-.86,4.4h11.59l-1.08,5.51H190.15l-.93,4.78H202.9l-1.19,5.7H180.8L186,244h20.43l-1.15,5.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "193.615px 257.025px"
    },
    id: "elfvn94v0enr7",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stopwatch--inject-28",
    className: "animable",
    style: {
      transformOrigin: "122.73px 112.145px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.15,164.16H48.58c0-20.28,8.21-41,22.52-56.9,15.06-16.71,34.61-25.91,55-25.91,41.67,0,70.78,30.42,70.78,74H182.34c0-35.53-22.59-59.4-56.21-59.4C93.17,95.92,63.15,128.44,63.15,164.16Z",
    style: {
      fill: "#407BFF",
      transformOrigin: "122.73px 122.755px"
    },
    id: "elucxvkep30ym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.14,160.11c2.33,0,4.22.23,4.21.44s-1.89.37-4.21.37-4.22-.19-4.22-.44S68.82,160.07,71.14,160.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "71.135px 160.512px"
    },
    id: "el9k6oa8nho1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2,128.17c2,1.28,3.35,2.59,3.13,2.94s-2-.36-4-1.57S77,127,77.21,126.6,79.25,126.9,81.2,128.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "80.7708px 128.843px"
    },
    id: "elm0a2i5kcc1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4,106.16c.95,2.13,1.42,4,1,4.16s-1.49-1.39-2.51-3.48-1.49-4-1-4.16S105.46,104,106.4,106.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "105.625px 106.5px"
    },
    id: "elkp4fmld3uh7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.6,103.54c-.58,2.26-1.37,4-1.76,3.92s-.31-2,.19-4.29,1.28-4,1.76-3.91S140.18,101.29,139.6,103.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "138.847px 103.36px"
    },
    id: "elhsflmmla02e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.72,122.6c-1.94,1.28-3.69,2.06-3.92,1.74s1.12-1.7,3-3.07,3.64-2.14,3.92-1.74S168.66,121.31,166.72,122.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "166.266px 121.918px"
    },
    id: "elpniclbbp5v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.65,154c-2.32,0-4.21-.18-4.21-.38s1.88-.4,4.21-.43,4.21.14,4.22.38S178,154,175.65,154Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "175.655px 153.593px"
    },
    id: "elk1zvm8xv3gj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.15,158.34a3.18,3.18,0,0,1-2-.69l-24.49-19a3.24,3.24,0,1,1,4-5.12L122,150.85l30.85-28.33a3.24,3.24,0,0,1,4.41,4.75l-32.87,30.2A3.26,3.26,0,0,1,122.15,158.34Z",
    style: {
      fill: "#407BFF",
      transformOrigin: "126.354px 139.997px"
    },
    id: "elleg7pqezuw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.89,
    y: 59.93,
    width: 29.66,
    height: 11.75,
    rx: 0.79,
    style: {
      fill: "#407BFF",
      transformOrigin: "124.72px 65.805px"
    },
    id: "elv4r9loe6o0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.05,
    y: 65.81,
    width: 15.33,
    height: 13.9,
    style: {
      fill: "#407BFF",
      transformOrigin: "124.715px 72.76px"
    },
    id: "ely1f86fqu2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwjbqx0w3cjc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.17,
    y: 100.66,
    width: 20.91,
    height: 12.7,
    rx: 1.29,
    style: {
      fill: "#407BFF",
      transformOrigin: "60.625px 107.01px",
      transform: "rotate(-51.08deg)"
    },
    className: "animable",
    id: "elsd4mfpyan"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.76,71.68c0,.17-6.29.3-14,.3s-14-.13-14-.3,6.28-.3,14-.3S138.76,71.52,138.76,71.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "124.76px 71.68px"
    },
    id: "el2hm2e64w00c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.18,115.68c-.16.18-2.28-1.44-4.9-3.41s-4.75-3.57-4.62-3.77,2.48,1.1,5.13,3.09S61.33,115.51,61.18,115.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "56.4213px 112.087px"
    },
    id: "el4gogg9m5l21",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.62,112.09c-.16.18-2.28-1.44-4.9-3.41s-4.76-3.57-4.63-3.77,2.49,1.1,5.14,3.1S63.77,111.92,63.62,112.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "58.8564px 108.497px"
    },
    id: "elsojc8rry9ci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.61,109.08c-.15.18-2.27-1.44-4.89-3.41S57,102.1,57.09,101.9s2.49,1.1,5.13,3.1S66.77,108.91,66.61,109.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "61.8533px 105.487px"
    },
    id: "elx9uarhjezm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.51,105.49c-.15.18-2.28-1.44-4.9-3.41S59.86,98.51,60,98.31s2.49,1.1,5.13,3.1S69.66,105.32,69.51,105.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "64.7559px 101.897px"
    },
    id: "elggn9coacj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elst40fwpqgxf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.86,
    y: 91.6,
    width: 20.91,
    height: 12.7,
    rx: 1.29,
    style: {
      fill: "#407BFF",
      transformOrigin: "184.315px 97.95px",
      transform: "rotate(47.45deg)"
    },
    className: "animable",
    id: "elwo2vh7ct4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.67,97.22c-.15-.18,1.76-2,4.1-4.34s4.23-4.17,4.41-4-1.45,2.3-3.82,4.62S175.81,97.39,175.67,97.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "179.928px 93.0508px"
    },
    id: "ela63ibnom44e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.86,100.16c-.16-.18,1.76-2,4.09-4.34s4.24-4.17,4.42-4-1.46,2.3-3.82,4.62S179,100.33,178.86,100.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "183.117px 95.9908px"
    },
    id: "el1jzhqxtrwgr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.39,103.57c-.16-.18,1.76-2,4.09-4.34s4.24-4.17,4.42-4-1.46,2.29-3.83,4.61S181.53,103.74,181.39,103.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "185.647px 99.4008px"
    },
    id: "el5luqc0ink5a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51,107c-.16-.18,1.76-2,4.09-4.34s4.24-4.17,4.42-4-1.46,2.3-3.83,4.62S184.65,107.14,184.51,107Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "188.767px 102.829px"
    },
    id: "elsydzv5cf5ee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.83,71.67c-.23,0-.42-2.6-.42-5.79s.19-5.8.42-5.8.43,2.6.43,5.8S114.07,71.67,113.83,71.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "113.835px 65.875px"
    },
    id: "el2x205u1dg87",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.33,71.67c-.23,0-.42-2.6-.42-5.79s.19-5.8.42-5.8.42,2.6.42,5.8S119.56,71.67,119.33,71.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "119.33px 65.875px"
    },
    id: "eleg74xs9sgrw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.82,71.67c-.23,0-.42-2.6-.42-5.79s.19-5.8.42-5.8.42,2.6.42,5.8S125.06,71.67,124.82,71.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "124.82px 65.875px"
    },
    id: "elk772rfm058k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.32,71.67c-.24,0-.42-2.6-.42-5.79s.18-5.8.42-5.8.42,2.6.42,5.8S130.55,71.67,130.32,71.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.32px 65.875px"
    },
    id: "elbut2f9x65iu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.81,71.67c-.23,0-.42-2.6-.42-5.79s.19-5.8.42-5.8.42,2.6.42,5.8S136,71.67,135.81,71.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "135.81px 65.875px"
    },
    id: "elv1subs6yfdt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljcw99uncchs"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 122.9,
    cy: 153.98,
    r: 7.34,
    style: {
      fill: "#407BFF",
      transformOrigin: "122.9px 153.98px",
      transform: "rotate(-45deg)"
    },
    className: "animable",
    id: "el0cslxhepegg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.24,154c-.07,0-.06-.65-.37-1.76a7.28,7.28,0,0,0-2.69-3.86,7,7,0,1,0,0,11.24,7.32,7.32,0,0,0,2.69-3.86c.31-1.11.3-1.76.37-1.76s0,.16,0,.47a5,5,0,0,1-.14,1.36,7.28,7.28,0,0,1-2.64,4.21,7.58,7.58,0,0,1-7.22,1.18,7.66,7.66,0,0,1,0-14.44,7.61,7.61,0,0,1,7.22,1.17,7.32,7.32,0,0,1,2.64,4.22,5,5,0,0,1,.14,1.36C130.29,153.82,130.27,154,130.24,154Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "122.705px 154px"
    },
    id: "eldz56fvz73u6",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-28",
    className: "animable",
    style: {
      transformOrigin: "420.274px 144.21px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.27,179.14l12.54-2a42.3,42.3,0,1,0-9.89-11.46h0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "420.372px 144.22px"
    },
    id: "el2ern6n6vfr5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.27,179.14s0-.28.14-.85l.48-2.56c.43-2.3,1.07-5.67,1.9-10.07a.1.1,0,0,1,.13-.08.06.06,0,0,1,.06,0h0l-.18.14a42.44,42.44,0,0,1-5.89-19.89,41.55,41.55,0,0,1,.25-6.54,45.88,45.88,0,0,1,1.42-6.87A42.41,42.41,0,0,1,416.24,102a42.35,42.35,0,0,1,35.67,14.07l1.7,2c.53.7,1,1.43,1.52,2.13a42,42,0,0,1,2.69,4.44c.44.74.72,1.56,1.09,2.33s.75,1.54,1,2.36a39.92,39.92,0,0,1,1.47,4.86,43.21,43.21,0,0,1,.15,19.52,42.42,42.42,0,0,1-35.45,32.48,46,46,0,0,1-7.05.41,55.33,55.33,0,0,1-6.53-.7,41.9,41.9,0,0,1-18.76-8.68l.09,0-9.38,1.41-2.39.35-.79.11.83-.15,2.41-.4,9.28-1.54.09,0a41.89,41.89,0,0,0,18.68,8.51,52.57,52.57,0,0,0,6.48.67,45.3,45.3,0,0,0,7-.43,42.11,42.11,0,0,0,35-32.2,42.78,42.78,0,0,0-.17-19.29,44,44,0,0,0-1.45-4.8c-.25-.81-.67-1.55-1-2.33s-.65-1.57-1.08-2.3a39.92,39.92,0,0,0-2.66-4.38c-.5-.7-1-1.42-1.5-2.11l-1.68-2a41.91,41.91,0,0,0-35.23-13.93A42.16,42.16,0,0,0,386.74,119,41.7,41.7,0,0,0,380,132.57a46.35,46.35,0,0,0-1.43,6.8,41,41,0,0,0-.28,6.49A42.32,42.32,0,0,0,384,165.65a.11.11,0,0,1,0,.15.11.11,0,0,1-.14,0h0l.18-.06c-.88,4.35-1.56,7.69-2,10-.23,1.13-.41,2-.53,2.58S381.27,179.14,381.27,179.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "420.224px 144.21px"
    },
    id: "eltp9nazyayb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.16,145.48a4.29,4.29,0,1,1,4.28,4.28A4.29,4.29,0,0,1,433.16,145.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "437.45px 145.47px"
    },
    id: "el7vviqsn5afm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,145.48a4.29,4.29,0,1,1,4.29,4.28A4.29,4.29,0,0,1,416,145.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "420.29px 145.47px"
    },
    id: "elvmfz3rrfncc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.89,147.62a4.29,4.29,0,1,1,5.86,1.57A4.3,4.3,0,0,1,398.89,147.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "402.605px 145.473px"
    },
    id: "eln1oegjvi94c",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-28",
    className: "animable",
    style: {
      transformOrigin: "245.71px 272.401px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.29,299c-2.63-1.25-7.06-3.86-9.8-4.88a13,13,0,0,0-8.57-.58c-1.61.54-3.22,1.83-3.23,3.53L88.44,305l10.85-2.86Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "88.49px 299.036px"
    },
    id: "elt32v21gcjfe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.53,298.89S68.22,294.7,65,293.05,45,283,42.19,283s-5.21.76-5.72,3.56l3.67,2.85.47,1.46,6.28,3.27L48,296.2l16,8.54s16.78,8.52,19.58,9,16.78,1.65,22.76,6.74l24-9.86s-6.93-9.84-12.27-12.27c-4.76-2.16-12.75-2.16-18.34.13Z",
    style: {
      fill: "rgb(255, 191, 157)",
      transformOrigin: "83.405px 301.74px"
    },
    id: "el4o90snrcuuy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.59,315s30.55,66.62,35.47,80c0,0,34.15-5.62,35.32-24.57l-44-60Z",
    style: {
      fill: "rgb(255, 191, 157)",
      transformOrigin: "138.985px 352.715px"
    },
    id: "eloqeiz7oryv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.22,300.4s-.12,0-.33,0a4.54,4.54,0,0,1-.92-.19,19.69,19.69,0,0,1-3.18-1.28c-1.3-.63-2.81-1.46-4.47-2.39-.83-.46-1.7-.95-2.61-1.42s-1.9-.88-2.91-1.32a40.09,40.09,0,0,0-5.78-2.1c-1.81-.45-3.55-.79-4.86-.35a4,4,0,0,0-2.24,2.26,10.73,10.73,0,0,1-.51,1.14s0-.12.05-.32a6.13,6.13,0,0,1,.27-.9,5.55,5.55,0,0,1,.71-1.31A3.44,3.44,0,0,1,50,291a5.45,5.45,0,0,1,2.41-.24,18.33,18.33,0,0,1,2.69.47A38.54,38.54,0,0,1,61,293.31c1,.44,2,.85,2.93,1.34s1.79,1,2.62,1.47c1.65.95,3.13,1.81,4.4,2.47A25.13,25.13,0,0,0,74,300C74.78,300.29,75.22,300.35,75.22,300.4Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "61.315px 295.559px"
    },
    id: "elhsoda79m5ut",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8,290.82a10.69,10.69,0,0,1-2.71-.94,55.31,55.31,0,0,0-6.35-2.53,9.63,9.63,0,0,0-3.65-.31,3.61,3.61,0,0,0-2.58,1.2,4.23,4.23,0,0,0-.75,1.83,2.37,2.37,0,0,1-.15.75,2.13,2.13,0,0,1,0-.77,4,4,0,0,1,.66-2,3.42,3.42,0,0,1,1.16-1,5.16,5.16,0,0,1,1.66-.47,9.7,9.7,0,0,1,3.85.29,38,38,0,0,1,6.36,2.7A26,26,0,0,1,56.8,290.82Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "48.6875px 288.662px"
    },
    id: "elsdvbprtzyy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,297s-.27.16-.78.34a22.93,22.93,0,0,1-2.23.68,36,36,0,0,1-7.59,1.13,37.27,37.27,0,0,1-7.66-.46c-1-.17-1.74-.34-2.27-.49a2.49,2.49,0,0,1-.81-.27c0-.08,1.2.15,3.14.39a46.2,46.2,0,0,0,7.58.31,47.23,47.23,0,0,0,7.53-1C103.76,297.27,104.93,296.93,105,297Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "94.33px 298.088px"
    },
    id: "ela3m93k4gp44",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.44,257.45,345,248.25,334,240l-58.7,11.32c-.94,1.72-10.45,15-10.45,15l-23.12,7.85a48.62,48.62,0,0,0-25.08,16,103.33,103.33,0,0,0-15,25.1c-10.4,24.41-25.41,52.61-25.41,52.61l-9.41-15.16-39.66,18.68s23.23,46.83,30.92,53.52c8.55,7.43,28.21,8.29,41.8-5.57,8.19-8.36,31.86-41.4,36.79-49.67L244,404.26l6.73,39.47L239.85,470.9h158.8l-6.57-25.68s6.47-66.93,8.26-79.39C404.55,336.44,389.44,257.45,389.44,257.45Z",
    style: {
      fill: "#407BFF",
      transformOrigin: "264.125px 355.45px"
    },
    id: "el5jnyl7o1c07",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.44,257.45s31.8,8.92,38.8,40.53c4.24,19.15,18.64,73.74,23.71,118.68,3,26.72,2.92,51.41,3,54.24h-48.8L385.47,266.37Z",
    style: {
      fill: "#407BFF",
      transformOrigin: "420.21px 364.175px"
    },
    id: "elrl9im0867k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.88,284.59s0,.12-.13.33l-.45.92c-.4.81-1,2-1.65,3.51-1.41,3-3.07,7.45-5.75,12.42l-.13.25-.22-.19c-3.3-2.81-6.88-6.19-10.58-9.84-6.55-6.5-12.29-12.55-16.53-16.84l-5.05-5.07L266,268.71a3.52,3.52,0,0,1-.46-.5,2.87,2.87,0,0,1,.53.43l1.44,1.3c1.24,1.14,3,2.83,5.17,4.95,4.31,4.23,10.1,10.24,16.63,16.73,3.7,3.65,7.26,7,10.52,9.86l-.36.06c2.7-4.9,4.42-9.33,5.9-12.31.73-1.51,1.34-2.67,1.78-3.46.2-.35.37-.65.51-.88A1.74,1.74,0,0,1,307.88,284.59Z",
    id: "elwwzt5bf0p8",
    className: "animable",
    style: {
      transformOrigin: "286.71px 285.115px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.62,249.38a3.09,3.09,0,0,1-.09.7c-.1.5-.22,1.16-.37,2-.36,1.72-1,4.2-1.82,7.22-1.73,6-4.53,14.29-8,23.24-1.83,4.74-3.63,9.22-5.31,13.19l-.13.31-.25-.22c-4.53-4-8.59-7.15-11.34-9.49-1.38-1.17-2.46-2.11-3.19-2.77l-.81-.76c-.19-.18-.28-.27-.27-.28a1.61,1.61,0,0,1,.32.22l.86.71,3.27,2.66c2.81,2.28,6.9,5.37,11.48,9.35l-.38.09c1.65-4,3.44-8.46,5.26-13.19,3.43-9,6.28-17.15,8.09-23.16.9-3,1.56-5.46,2-7.17.19-.81.35-1.46.47-2A4.55,4.55,0,0,1,345.62,249.38Z",
    id: "el2ujl4xtqrsr",
    className: "animable",
    style: {
      transformOrigin: "329.83px 272.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.75,399.83a.73.73,0,0,1-.09-.22l-.21-.68q-.27-1-.75-2.64c-.34-1.14-.67-2.55-1.07-4.19s-.83-3.52-1.26-5.6a275.46,275.46,0,0,1-4.66-32.86c-1.13-12.93-1.38-24.68-1.32-33.17,0-4.25.11-7.69.23-10.06.06-1.16.1-2.07.13-2.74,0-.28,0-.52.05-.71a.92.92,0,0,1,0-.24,1.27,1.27,0,0,1,0,.25v.71c0,.67,0,1.58,0,2.73,0,2.38-.08,5.81-.06,10.06,0,8.48.34,20.22,1.47,33.12a302.87,302.87,0,0,0,4.5,32.84c.41,2.08.79,4,1.18,5.6s.68,3.07,1,4.21l.66,2.66.15.69C242.75,399.75,242.76,399.83,242.75,399.83Z",
    id: "els32wrqznlk",
    className: "animable",
    style: {
      transformOrigin: "238.068px 353.275px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.08,292.51a1.13,1.13,0,0,1,.14.28c.09.21.21.48.35.82.32.76.75,1.83,1.31,3.18.28.7.61,1.46.93,2.31l.95,2.8c.34,1,.7,2.09,1.09,3.23s.65,2.39,1,3.68c3,10.29,4.5,25.18,3.64,41.47s-2.78,31-4,41.56c-.61,5.28-1.11,9.57-1.46,12.57-.17,1.45-.31,2.6-.41,3.41l-.12.89a1.21,1.21,0,0,1-.06.3,1.13,1.13,0,0,1,0-.3l.07-.9c.08-.82.19-2,.32-3.42.28-3,.72-7.28,1.29-12.59,1.09-10.62,2.93-25.28,3.81-41.54s-.6-31.07-3.47-41.36l-1-3.68-1-3.22c-.32-1-.62-1.95-.9-2.81s-.62-1.63-.89-2.33c-.52-1.37-.92-2.44-1.22-3.21-.12-.35-.22-.62-.3-.84A1,1,0,0,1,392.08,292.51Z",
    id: "el4uxmw830c7l",
    className: "animable",
    style: {
      transformOrigin: "396.905px 350.76px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.5,401.93c-.14,0-.31-7.62-.37-17s0-17,.15-17,.31,7.62.37,17S176.65,401.93,176.5,401.93Z",
    id: "el9u289nbbwtu",
    className: "animable",
    style: {
      transformOrigin: "176.39px 384.93px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.8,448.08l0-.42c0-.3.08-.7.14-1.22.14-1.1.33-2.67.58-4.69.13-1,.27-2.15.43-3.38s.28-2.59.43-4c.29-2.9.69-6.19,1-9.85.15-1.82.3-3.74.47-5.73s.25-4.07.38-6.22c.3-4.3.43-8.91.6-13.75.22-9.69.19-20.35-.31-31.52s-1.52-21.79-2.65-31.42c-.63-4.81-1.18-9.38-1.89-13.63-.33-2.13-.62-4.19-1-6.16s-.69-3.86-1-5.67c-.61-3.61-1.31-6.85-1.88-9.71-.29-1.43-.55-2.76-.8-4s-.52-2.33-.75-3.33l-1-4.61c-.1-.51-.19-.91-.25-1.2s-.07-.42-.07-.42a2.61,2.61,0,0,1,.12.4l.31,1.19,1.11,4.6.79,3.32c.26,1.22.54,2.54.85,4,.59,2.85,1.32,6.09,1.95,9.7q.5,2.71,1,5.67c.36,2,.65,4,1,6.16.72,4.26,1.29,8.83,1.94,13.64,1.15,9.64,2.13,20.27,2.69,31.45s.52,21.86.27,31.56c-.19,4.85-.33,9.46-.65,13.76-.14,2.15-.24,4.23-.41,6.23s-.35,3.91-.51,5.74c-.28,3.66-.71,7-1,9.84-.17,1.45-.33,2.8-.47,4s-.33,2.36-.48,3.38c-.29,2-.52,3.58-.67,4.67l-.19,1.22A2.39,2.39,0,0,1,320.8,448.08Z",
    id: "elrd2g14o31s",
    className: "animable",
    style: {
      transformOrigin: "319.332px 367.615px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.94,340.14l.2,0,.63-.07,2.45-.28,9.37-1,33.35-3.46.25,0v.25c.25,10.09.55,21.51.86,33.62v.11l-.07.07-4,4.33L370.4,389.29l-.13.14-.17-.09-24.57-12.2-.11-.05V377c-1.07-11.15-2-20.37-2.57-26.84-.3-3.18-.53-5.68-.69-7.41-.07-.83-.13-1.47-.17-1.94s0-.64,0-.64,0,.24.09.68.13,1.13.23,2c.18,1.75.45,4.26.8,7.46.67,6.42,1.62,15.59,2.78,26.68l-.12-.17,24.6,12.13-.29.05,14.55-15.64,4-4.32-.07.18c-.29-12.11-.57-23.52-.81-33.62l.26.22L354.76,339l-9.43.88-2.51.22-.65.06Z",
    id: "el97425girfs5",
    className: "animable",
    style: {
      transformOrigin: "365.495px 362.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.25,347.18a10.69,10.69,0,0,1-1.73.33c-1.12.18-2.74.41-4.75.67-4,.51-9.59,1.1-15.74,1.69l-15.76,1.54-4.77.5a10.31,10.31,0,0,1-1.75.13,10.69,10.69,0,0,1,1.73-.33c1.12-.18,2.74-.41,4.75-.67,4-.51,9.59-1.1,15.75-1.69l15.75-1.54,4.77-.5A10.31,10.31,0,0,1,388.25,347.18Z",
    id: "el6ot0xeqm3ef",
    className: "animable",
    style: {
      transformOrigin: "366px 349.61px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3y08gqdzvqq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "401.943px 354.295px"
    },
    className: "animable",
    id: "elq0wqdek19j9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.91,386.51l1.68,20.43c3.71-17.5,9.54-36.31,8.63-54.17s-2.59-34.95-12.65-51.12a101.5,101.5,0,0,1,5.91,38C400.56,360.55,397.91,386.51,397.91,386.51Z",
    id: "elirls3dqyvs",
    className: "animable",
    style: {
      transformOrigin: "401.943px 354.295px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M169.88,348.48a5.73,5.73,0,0,0-2.7-2.83c-1.4-.48-2.92.2-4.25.86l-36.28,18.06c-2.39,1.19-5,2.6-5.88,5.1-1.15,3.2,1,6.58,3,9.33,3.34,4.59,7.34,9.59,13,10.24l31.21-21.4c3.81-.56,6.18-4.81,6-8.66S171.82,351.82,169.88,348.48Z",
    style: {
      fill: "#407BFF",
      transformOrigin: "147.219px 367.364px"
    },
    id: "el79950kcy5ye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,361.56a2,2,0,0,1-.32.35l-1,.93c-.86.8-2.13,1.93-3.72,3.29-3.19,2.73-7.72,6.36-13,10.06S145.67,382.94,142,385c-1.82,1.05-3.31,1.87-4.35,2.41l-1.2.61c-.28.14-.43.2-.44.18a1.57,1.57,0,0,1,.39-.27l1.15-.7,4.26-2.55c3.59-2.16,8.48-5.26,13.7-8.95s9.78-7.26,13-9.91l3.83-3.17,1-.85C173.68,361.64,173.81,361.54,173.82,361.56Z",
    id: "elctwwdmg8yk7",
    className: "animable",
    style: {
      transformOrigin: "154.915px 374.881px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3rmrqwiimsv"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "330.593px 278.693px"
    },
    className: "animable",
    id: "elmt6aydpg8q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.15,251.67c-4.27,14.18-10.25,30.22-15.3,44-4.3-3.65-10.32-8.48-14.63-12.14a120.7,120.7,0,0,0,13.29,20.77c.6.75,1.4,1.57,2.33,1.39s1.35-1.14,1.67-2l7.87-20.83C344.06,273.12,347.61,261.76,345.15,251.67Z",
    id: "elw6ayge9ykf",
    className: "animable",
    style: {
      transformOrigin: "330.593px 278.693px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M277.65,97.4c13-3.74,25.16,0,37.15,6.22s21.66,16.49,27.92,28.44c6.6,12.59,9.52,27.26,7.13,41.27s-10.31,27.21-22.17,35c-16.21,10.68-38.55,10.12-55.24.23s-27.68-28.12-30.59-47.31c-2-13.22-.38-27.16,5.79-39s17.08-21.44,30-24.86",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "295.858px 156.033px"
    },
    id: "el8lt80h07qx7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.33,138.09c-2.51-4.83-2.4-10.56-3.77-15.84-3-11.61-13.6-20-25.12-23.35-10.71-3.13-23.1-.78-35,4.6-8.14,3.69-15.55,9.35-20.41,16.85a37.31,37.31,0,0,0-3,34.06l59.39-15.62c6.18,4,12.51,8.13,19.66,10a12.74,12.74,0,0,0,6.42.29,5.66,5.66,0,0,0,4.25-4.41C323,142.29,321.42,140.2,320.33,138.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "276.516px 125.953px"
    },
    id: "elwetw8lh6s1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.5,243.4,319.17,135.58c-.68-5.1-3-10.3-8.13-10.06l-54-5.2c-16.92.78-24.86,23-23.36,39.83,1.67,18.74,4.44,41.55,8.75,55.07,8.67,27.17,30.56,27.45,30.56,27.45s1.33,5.4,3,15.5l35,23.28Z",
    style: {
      fill: "rgb(255, 191, 157)",
      transformOrigin: "284.001px 200.885px"
    },
    id: "el32wlob87o1k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.73,180.66a3.61,3.61,0,0,0,4,3.07,3.45,3.45,0,0,0,3.19-3.78,3.63,3.63,0,0,0-4-3.08A3.47,3.47,0,0,0,246.73,180.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250.325px 180.301px"
    },
    id: "elnjo2q79x0wk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.43,171.21c.51.4,2.91-2,6.76-2.59s6.95.92,7.3.38c.17-.24-.41-1-1.77-1.72a10,10,0,0,0-5.93-.88,9.49,9.49,0,0,0-5.29,2.65C240.45,170.13,240.18,171,240.43,171.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "247.431px 168.766px"
    },
    id: "ela7099dyz58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.26,174.88a3.61,3.61,0,0,0,4,3.08,3.45,3.45,0,0,0,3.19-3.78,3.61,3.61,0,0,0-4-3.08A3.46,3.46,0,0,0,282.26,174.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "285.855px 174.53px"
    },
    id: "el994ww3i4gep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,166.12c.51.4,2.92-2,6.76-2.59s6.95.92,7.3.38c.17-.24-.41-1-1.77-1.72a10,10,0,0,0-5.94-.88A9.53,9.53,0,0,0,278,164C277,165,276.73,166,277,166.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "283.995px 163.675px"
    },
    id: "el4fm6qe0xuiu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.72,196.79c0-.22-2.47-.27-6.41-.17-1,0-2,0-2.23-.65s-.09-1.79.21-3q.84-3.77,1.77-7.91c2.4-11.26,4-20.45,3.53-20.54s-2.77,9-5.18,20.2c-.57,2.77-1.12,5.42-1.63,7.95-.2,1.17-.65,2.53.08,3.92a2.44,2.44,0,0,0,1.83,1.19,6.33,6.33,0,0,0,1.7,0C266.32,197.36,268.74,197,268.72,196.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "263.589px 181.178px"
    },
    id: "elogqas1vicg8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,242.67A71.62,71.62,0,0,0,308.78,227s-8.73,21.85-34,24.05Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "290.89px 239.025px"
    },
    id: "els7cm28zm0h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.76,205.81a7,7,0,0,1,5.81-3.52A6.39,6.39,0,0,1,282.3,204a4.06,4.06,0,0,1,1,4.54c-.81,1.61-2.93,2.28-4.84,2a14.7,14.7,0,0,1-5.36-2.18,4.21,4.21,0,0,1-1.27-1,1.3,1.3,0,0,1-.22-1.43",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "277.548px 206.441px"
    },
    id: "elu66h8nvnv9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.44,197.72c-.64.06,0,4.24-3.13,7.74s-7.62,3.73-7.57,4.31c0,.28,1.12.66,3,.43a10.51,10.51,0,0,0,6.36-3.37,9.13,9.13,0,0,0,2.35-6.44C281.34,198.62,280.72,197.66,280.44,197.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "275.598px 203.994px"
    },
    id: "elh0lrjijesk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.9,154.64c.54,1,4.3-.09,8.89-.24s8.43.53,8.88-.5c.2-.49-.58-1.37-2.21-2.16a15.48,15.48,0,0,0-13.54.56C276.37,153.22,275.66,154.17,275.9,154.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "284.778px 152.752px"
    },
    id: "elv73m5nmibkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,154.24c.81.77,3.32-.54,6.5-1.07s6-.31,6.44-1.32c.21-.49-.35-1.29-1.65-1.94a9.55,9.55,0,0,0-10.43,1.92C238.85,152.9,238.62,153.86,239,154.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "245.405px 151.804px"
    },
    id: "elqnz0n0ariiq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.07,128.86c-7.28-15.44-33.62-34.61-50.34-31.18l-24.79,19.76A26.23,26.23,0,0,0,274.24,135c4.95.82,10.75.45,14.13,4.17s2.57,10.12,5.84,14.07c4.53,5.48,14.69,3.84,18.35,9.94,1.61,2.66,1.42,6.12,3.06,8.76,2.2,3.51,12.29,7,16,5.22s2.87-8.42,3.68-12.09c1.39-6.25.07-9.22-1.09-12.46C331.5,144.93,332.55,136.22,329.07,128.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "294.919px 137.459px"
    },
    id: "elvgbgw49ilb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.55,182c-.31-2.08,1.34-7.33,3.34-8,5.34-1.68,15.27-2.75,17.48,11.13,3,19-16.64,18.09-16.77,17.55S321.63,189.14,320.55,182Z",
    style: {
      fill: "rgb(255, 191, 157)",
      transformOrigin: "331.097px 187.965px"
    },
    id: "el6xosfwyc2oq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.25,194.58c.08-.08.37.18,1,.34a3.3,3.3,0,0,0,2.48-.34c1.88-1.05,3.06-4.5,2.61-7.94a11.06,11.06,0,0,0-1.68-4.58,3.85,3.85,0,0,0-2.89-2.14,1.69,1.69,0,0,0-1.8,1.22c-.17.57,0,.93-.09,1s-.45-.25-.43-1.06a2.13,2.13,0,0,1,.56-1.3,2.51,2.51,0,0,1,1.75-.78c1.48-.13,3,1,3.92,2.39a11.45,11.45,0,0,1,2,5.11c.49,3.84-.9,7.73-3.52,9a3.61,3.61,0,0,1-3.1,0C329.36,195,329.19,194.62,329.25,194.58Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "332.613px 187.42px"
    },
    id: "elicqzbk1q70p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.82,111.05c-.87,8-11.54,19.25-16,25.88-8.57,12.65-10.09,16.7-7.07,42.46-5.68-8.37-10.24-16.69-11-26.78s1.78-20.56,7.94-28.58,16.07-13.3,26.18-13",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "241.745px 145.204px"
    },
    id: "elvl33ry4bbs8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.13,83.92c4-4.41,9.78-7.28,15.78-8.78,8.55-2.14,17.94-1.56,25.72,2.16S359.43,88,361,96a23,23,0,0,1-8.28,22.24,38.53,38.53,0,0,0,15.81,9.26c-1.62,2.43-4.61,3.85-7.63,4.36a35,35,0,0,1-9.14-.06,15.76,15.76,0,0,0,8.74,6.38,29,29,0,0,1-14.89-.49,57.91,57.91,0,0,1-13.47-6.05c-14.63-8.49-22.7-15.93-32.58-29C298.27,97,300.1,88.34,304.13,83.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "333.841px 106.412px"
    },
    id: "el8g33rjdsb1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.67,124c-10.74-15.69-24.41-24.08-36.78-26.69",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "317.28px 110.655px"
    },
    id: "elx5x615edlvc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.89,97.31a10.56,10.56,0,0,0,1.75.53c1.13.32,2.76.81,4.72,1.56a58.13,58.13,0,0,1,14.25,8,73.17,73.17,0,0,1,11.82,11.31c1.32,1.63,2.39,3,3.08,3.9a10.38,10.38,0,0,0,1.16,1.43,11.1,11.1,0,0,0-1-1.56c-.64-1-1.66-2.35-2.95-4A67.2,67.2,0,0,0,320,106.9,54.25,54.25,0,0,0,305.5,99a41.7,41.7,0,0,0-4.8-1.39A11.47,11.47,0,0,0,298.89,97.31Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "317.28px 110.675px"
    },
    id: "elapjnvvtittp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.47,137.37l-.24.08-.7.28c-.6.26-1.5.6-2.68,1a43.21,43.21,0,0,1-10.3,2.1,56.32,56.32,0,0,1-15.53-1,100.82,100.82,0,0,1-18.26-5.69c-6.3-2.57-12.24-5.21-17.53-7.8a105,105,0,0,1-13.53-7.84,67,67,0,0,1-8.18-6.64c-.92-.85-1.58-1.56-2-2l-.53-.53c-.12-.11-.18-.17-.19-.16s0,.07.15.2l.49.57c.43.5,1.07,1.23,2,2.11a62.51,62.51,0,0,0,8.11,6.81,100.32,100.32,0,0,0,13.53,8c5.3,2.63,11.23,5.29,17.54,7.87a99.71,99.71,0,0,0,18.38,5.67,55.37,55.37,0,0,0,15.67.86A41.91,41.91,0,0,0,344.93,139c1.17-.45,2.06-.82,2.65-1.12l.67-.33C348.4,137.42,348.48,137.38,348.47,137.37Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "303.634px 125.32px"
    },
    id: "eldt49emwpvrv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.81,231.54,290,228c.13-.07,12.69-6.51,17.52-10.57,11.38-9.56,21.84-24.83,21.95-25l3.3,2.25c-.44.65-10.87,15.88-22.68,25.8C304.89,224.82,292.34,231.27,291.81,231.54Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "311.385px 211.985px"
    },
    id: "elzin4e4am7t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.16,220.49S284,228.15,284,229.85s2.72,5.1,4.76,4.93,7.94-3.49,9-4.85,2.94-4.86,5-6.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "293.38px 227.638px"
    },
    id: "eljo64rp13cz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.63,169l-4-.19A93.68,93.68,0,0,0,322.77,135c-8.68-22.36-25.37-34.36-49.59-35.68a29.48,29.48,0,0,0-6.58.45l1.75-1.66a9.66,9.66,0,0,1,2.91-1.89h0a9.82,9.82,0,0,1,4.67-.72c30.58,2.65,44.4,22.09,50.61,38.17A96,96,0,0,1,332.63,169Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "299.622px 132.23px"
    },
    id: "elff931rnndc9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 330.63,
    cy: 187.15,
    rx: 12.67,
    ry: 18.22,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "330.63px 187.15px"
    },
    id: "elj7olqn18zsa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.3,187.15a.87.87,0,0,1,0-.25c0-.2,0-.44-.06-.74a25.71,25.71,0,0,0-.29-2.82,21.63,21.63,0,0,0-3.91-9.53,14.08,14.08,0,0,0-2.38-2.45,10.82,10.82,0,0,0-3.23-1.75,9,9,0,0,0-3.88-.37,10,10,0,0,0-3.88,1.45,15.43,15.43,0,0,0-5.54,7,24.8,24.8,0,0,0,0,19,15.41,15.41,0,0,0,5.54,7,10,10,0,0,0,3.88,1.45,9.15,9.15,0,0,0,3.88-.37,10.82,10.82,0,0,0,3.23-1.75,14.44,14.44,0,0,0,2.38-2.45,21.63,21.63,0,0,0,3.91-9.53,26,26,0,0,0,.29-2.82c0-.3,0-.54.06-.74a.79.79,0,0,1,0-.25.67.67,0,0,1,0,.25v.74a24.24,24.24,0,0,1-.2,2.85,21.31,21.31,0,0,1-3.82,9.72,14.42,14.42,0,0,1-2.42,2.54,11,11,0,0,1-3.35,1.85,9.51,9.51,0,0,1-4.07.41,10.37,10.37,0,0,1-4.07-1.5,15.7,15.7,0,0,1-5.75-7.16,25.1,25.1,0,0,1,0-19.4,15.7,15.7,0,0,1,5.75-7.16,10.37,10.37,0,0,1,4.07-1.5,9.51,9.51,0,0,1,4.07.41,11,11,0,0,1,3.35,1.85,14.08,14.08,0,0,1,2.42,2.54,21.23,21.23,0,0,1,3.82,9.72,24.24,24.24,0,0,1,.2,2.84v.75A.72.72,0,0,1,343.3,187.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "330.491px 187.23px"
    },
    id: "el4hir3g25taf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 332.58,
    cy: 186.13,
    rx: 8.07,
    ry: 11.6,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "332.58px 186.13px"
    },
    id: "el55261qipb4t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.65,186.13c-.06,0,0-.88-.29-2.43a13.56,13.56,0,0,0-2.5-6,7.48,7.48,0,0,0-3.54-2.63,5.68,5.68,0,0,0-2.44-.23,6.21,6.21,0,0,0-2.43.91,9.76,9.76,0,0,0-3.49,4.4,15.51,15.51,0,0,0-1.19,6,15.35,15.35,0,0,0,1.19,6,9.76,9.76,0,0,0,3.49,4.4,6.21,6.21,0,0,0,2.43.91,5.68,5.68,0,0,0,2.44-.23,7.48,7.48,0,0,0,3.54-2.63,13.56,13.56,0,0,0,2.5-6c.25-1.55.23-2.43.29-2.42a5,5,0,0,1,0,.63,14.36,14.36,0,0,1-.12,1.82,13.38,13.38,0,0,1-2.41,6.22,7.77,7.77,0,0,1-3.7,2.82,6,6,0,0,1-2.62.28,6.77,6.77,0,0,1-2.63-1,10.1,10.1,0,0,1-3.7-4.59,16.08,16.08,0,0,1,0-12.43,10.1,10.1,0,0,1,3.7-4.59,6.78,6.78,0,0,1,2.62-1,6.06,6.06,0,0,1,2.63.28,7.77,7.77,0,0,1,3.7,2.82,13.38,13.38,0,0,1,2.41,6.22,14.36,14.36,0,0,1,.12,1.82A5.29,5.29,0,0,1,340.65,186.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "332.44px 186.145px"
    },
    id: "elrfq1rzxi02",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.14,
    cy: 186.13,
    rx: 5.8,
    ry: 8.34,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "333.14px 186.13px"
    },
    id: "eltzloxbd5sm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.94,186.13c-.05,0-.05-.63-.23-1.74a10,10,0,0,0-1.82-4.31,5.31,5.31,0,0,0-2.52-1.87,4,4,0,0,0-3.45.49c-2.17,1.43-3.32,4.43-3.33,7.42s1.16,6,3.33,7.43a4,4,0,0,0,3.45.49,5.31,5.31,0,0,0,2.52-1.87,10,10,0,0,0,1.82-4.31c.18-1.11.18-1.74.23-1.73a1.42,1.42,0,0,1,0,.45,10.1,10.1,0,0,1-.07,1.31,9.6,9.6,0,0,1-1.72,4.51,5.68,5.68,0,0,1-2.69,2,4.51,4.51,0,0,1-1.91.21,4.85,4.85,0,0,1-1.92-.7,7.31,7.31,0,0,1-2.69-3.34,11.56,11.56,0,0,1,0-9,7.31,7.31,0,0,1,2.69-3.34,4.85,4.85,0,0,1,1.92-.7,4.51,4.51,0,0,1,1.91.21,5.68,5.68,0,0,1,2.69,2,9.6,9.6,0,0,1,1.72,4.51,10.1,10.1,0,0,1,.07,1.31A1.52,1.52,0,0,1,338.94,186.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "332.998px 186.07px"
    },
    id: "eluxs8t3zgv",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService247Animate);
export default __webpack_public_path__ + "static/media/service-247-animate.3d424b2cd805fdeef829869336310cf9.svg";
export { ForwardRef as ReactComponent };